import clsx from "clsx";
import React from "react";
import css from "./Styles/fixed-ratio-box.module.scss";
import * as C from "@components";

interface FixedRatioBoxProps extends React.ComponentProps<"div">
{
    aspecRatio?: number;
    wrapperNodes?: React.ReactNode;
    imageIndent?: C.MediaSpecific<C.ImageCardImageIndentBasic>;
}

export const FixedRatioBox = ({ className, style, aspecRatio = 1, imageIndent, wrapperNodes, ...props }: FixedRatioBoxProps): React.ReactComponentElement<"div", FixedRatioBoxProps> =>
{
    const wrapperStyles: React.CSSProperties =
    {
        ["--aspect-ratio" as string]: aspecRatio,
        ["--content__indent-padding-image" as any]: `${imageIndent?.all?.indentPaddingImage ?? 0}px`,
        ["--content__indent-padding-image--mobile" as any]: `${imageIndent?.mobile?.indentPaddingImage ?? imageIndent?.all?.indentPaddingImage ?? 0}px`,
        ["--content__indent-padding-image--ipad" as any]: `${imageIndent?.mobile?.indentPaddingImage ?? imageIndent?.ipad?.indentPaddingImage ?? imageIndent?.all?.indentPaddingImage ?? 0}px`,
        ["--content__indent-padding-image--desktop" as any]: `${imageIndent?.mobile?.indentPaddingImage ?? imageIndent?.desktop?.indentPaddingImage ?? imageIndent?.ipad?.indentPaddingImage ?? imageIndent?.all?.indentPaddingImage ?? 0}px`,
        ...style,
    }

    return (
        <div className={css["wrapper"]} style={wrapperStyles} >
            <div {...props} className={clsx(css["box"], className)} />
            {wrapperNodes}
        </div>
    );
}